<template>
  <div v-if="showIgaliojimai">
    <h3 class="mt-3">{{ $t('Įgaliojimas') }}</h3>
    <v-card class="ntr-card-gray pt-3 pb-2 px-2 mt-3" flat>
      <el-overlay-loading :loading="loading" :absolute="true" />
      <v-tabs class="mb-0" v-model="igaliojimaiTab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          class="igaliojimai-tab"
          @click.native.prevent.stop.capture="clickSarasas"
        >
          <h4>{{ $t('Pasirinkti iš sąrašo') }}</h4>
        </v-tab>
        <v-tab
          class="igaliojimai-tab"
          @click.native.prevent.stop.capture="clickNotaras"
        >
          <h4>{{ $t('Notarinis įgaliojimas') }}</h4>
        </v-tab>
        <v-tab
          class="igaliojimai-tab"
          @click.native.prevent.stop.capture="clickRinkmena"
        >
          <h4>{{ $t('Prisegti įgaliojimą') }}</h4>
        </v-tab>
      </v-tabs>
      <template v-if="showFail">
        <v-row align="baseline" no-gutters class="mb-0">
          <v-col cols="12">
            <el-savitarna-alert dense outlined type="warning2">
              {{ tikVienasIgaliojimas }}
            </el-savitarna-alert>
          </v-col>
        </v-row>
      </template>

      <v-tabs-items v-model="igaliojimaiItems">
        <v-tab-item>
          <v-row>
            <v-col cols="12" class="mx-3">
              <igaliojimas-sarasas
                :readonly="isReadonly"
                :pazyma="pazyma"
                @loaded="igaliojimasLoaded"
                @isLoading="igaliojimasLoading"
                @updatePazyma="updatePazyma"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col cols="12">
              <igaliojimas-notaras
                :readonly="readonly"
                :foreign="isForeign"
                :pazyma="pazyma"
                :asm-kodas="asmuo.asm_asmens_kodas"
                @loaded="igaliojimasLoaded"
                @isLoading="igaliojimasLoading"
                @updatePazyma="updatePazyma"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col cols="12" class="">
              <igaliojimas-upload
                :readonly="isReadonly"
                :pazyma="pazyma"
                :multiple="false"
                :instant="true"
                @loaded="igaliojimasLoaded"
                @isLoading="igaliojimasLoading"
                @updatePazyma="updatePazyma"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import IgaliojimasSarasas from './IgaliojimasSarasas'
import IgaliojimasNotaras from './IgaliojimasNotaras'
import IgaliojimasUpload from './IgaliojimasUpload'

export default {
  name: 'IgaliojimaiTab',
  components: { IgaliojimasSarasas, IgaliojimasNotaras, IgaliojimasUpload },
  props: {
    pazyma: Object,
    asmuo: Object,
    readonly: Boolean,
  },
  data() {
    return {
      showFail: false,
      igaliojimaiTab: 0,
      igaliojimaiItems: 0,
      loading: true,
    }
  },
  computed: {
    showIgaliojimai() {
      return this.pazyma && this.asmuo && this.pazyma.paz_id
    },
    isReadonly() {
      return this.pazyma?.paz_readonly
    },
    igaliojimasTipas() {
      return this.pazyma.paz_igaliojimai?.tipas ?? null
    },
    yraIgaliojimas() {
      return this.igaliojimasTipas
    },
    igaliojimasSarasas() {
      return { tipas: 1, tab: 0 }
    },
    igaliojimasNotaras() {
      return { tipas: 2, tab: 1 }
    },
    igaliojimasRinkmena() {
      return { tipas: 3, tab: 2 }
    },

    tikVienasIgaliojimas() {
      const msgTipas = {
        1: 'Pasirinktas įgaliojimas iš sąrašo.',
        2: 'Pasirinktas notarinis įgaliojimas iš Įgaliojimų registro.',
        3: 'Įgaliojimas prisegtas.',
      }

      const msg = `${
        msgTipas[this.igaliojimasTipas]
      } Paslaugai užsakyti turi būti pasirinktas tik vienas įgaliojimas`

      return msg
    },
    isForeign() {
      return this.asmuo.foreign
    },
  },
  created() {
    this.defaultTab()
  },
  methods: {
    defaultTab() {
      if (this.yraIgaliojimas) {
        this.igaliojimaiTab = this.igaliojimasTipas - 1
        this.igaliojimaiItems = this.igaliojimaiTab
      }
    },
    clickSarasas() {
      this.checkIgaliojimas(this.igaliojimasSarasas)
    },
    clickNotaras() {
      this.checkIgaliojimas(this.igaliojimasNotaras)
    },
    clickRinkmena() {
      this.checkIgaliojimas(this.igaliojimasRinkmena)
    },
    checkIgaliojimas(igaliojimas) {
      if (this.loading || this.isReadonly) {
        return
      }

      if (this.yraIgaliojimas && this.igaliojimasTipas !== igaliojimas.tipas) {
        this.showFail = true
        return
      }
      this.showFail = false
      this.igaliojimaiTab = igaliojimas.tab
      this.igaliojimaiItems = igaliojimas.tab
    },
    igaliojimasLoaded() {
      this.loading = false
      console.log('igaliojimas loaded')
      this.$emit('loaded')
    },
    igaliojimasLoading() {
      this.loading = true
    },
    updatePazyma() {
      this.showFail = false
      this.loading = false
      this.$emit('updatePazyma')
    },
  },
}
</script>

<style lang="scss" scoped>
.igaliojimai-tab {
  h4 {
    font-size: 0.84rem;
  }
}
</style>
